import React from 'react'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = {
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(22, 22, 22, 0.78)',
  },
  contentContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    textAlign: 'center',
  },
}

const Intro = ({
  classes,
  theme,
  wrapperClassName,
  gatsbyImage,
  inspirationalQuote,
}) => (
  <div className={wrapperClassName}>
    {gatsbyImage}
    <div className={classes.overlay}>
      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <Typography
            variant="display3"
            style={{ color: '#fff', fontWeight: 500 }}
          >
            REAL
          </Typography>
          <Typography
            variant="headline"
            style={{ color: theme.palette.text.lighter, fontWeight: 300 }}
            gutterBottom
          >
            SUCCESS STORIES
          </Typography>
          <Typography
            style={{
              color: '#fff',
              fontStyle: 'italic',
              fontWeight: 300,
              fontFamily: 'Times',
              fontSize: '1.2em',
            }}
          >
            {inspirationalQuote}
          </Typography>
        </div>
      </div>
    </div>
  </div>
)

export default withStyles(styles, { withTheme: true })(Intro)



// WEBPACK FOOTER //
// ./src/components/Storiespage/Intro.js